<script setup>
import { useGlobalStore } from '@/stores/global'

const global = useGlobalStore()
</script>

<template>
	<footer class="py-10 text-white">
		<div class="container">
			<div class="flex flex-col items-center gap-8">
				<a href="https://www.snk-corp.co.jp" target="_blank">
					<img class="h-7" src="https://cdn.fatalfury.club/preorder-platform/images/logos/snk-blue.svg" alt="SNK Logo" />
				</a>
				<div>
					<ul class="flex gap-3">
						<li v-for="social in global.socials">
							<a class="transition-colors duration-300 hover:text-fury-orange-500" :href="social.link">
								<i :class="['text-2xl', social.icon]" />
							</a>
						</li>
					</ul>
				</div>
				<div class="w-full justify-center text-center text-xs font-medium">
					<div>* "PS", "Playstation", "PS4" and "PS5" are registered trademarks of Sony Interactive Entertainment Inc.</div>
					<div>* © 2025 Valve Corporation. Steam and the Steam logo are trademarks and/or registered trademarks of Valve Corporation in the U.S. and/or other countries.</div>
					<div>* © 2025, Epic Games, Inc. All rights reserved. Epic, Epic Games, and the Epic Games logo are trademarks or registered trademarks of Epic Games, Inc. in the United States of America and elsewhere.</div>
				</div>
				<a href="https://www.snk-corp.co.jp/us/kofstudio/" target="_blank">
					<img class="h-14" src="https://cdn.fatalfury.club/preorder-platform/images/logos/kof-studio.svg" alt="KOF Studio Logo" />
				</a>
				<div class="text-xs font-medium uppercase">&copy;SNK Corporation All Rights Reserved.</div>
			</div>
		</div>
	</footer>
</template>
